import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { Button, Pagination, Row, Col, Select, Spin, Icon } from 'antd';

import { enterpriseList } from '../../actions/sessionActions';
import { APIs } from '../../utils/apis';
import { getNoAuth } from '../../utils/httpRequests';

const { Option } = Select;
const antIcon = <Icon type="loading" style={{ fontSize: 80 }} spin />;

const columns = [
  {
    title: 'Enterprise User ID',
    width: 10
  },
  //   {
  //     title: 'Enterprise Name',
  //     width: 15
  //   },
  {
    title: 'Total Count',
    width: 15
  },
  {
    title: 'Uploaded?',
    width: 10
  },
  {
    title: 'Deleted?',
    width: 10
  },
  {
    title: 'SLA Config ID',
    width: 10
  },
  {
    title: 'Created At',
    width: 30
  },
  {
    title: 'File Link',
    width: 15
  }
];

const EDD = () => {
  const [state, setState] = useState({
    enterprise: { list: [] },
    enterpriseId: null,
    key: null,
    list: [],
    totalRecords: 0,
    pageNo: 1,
    pageSize: 10,
    totalPages: 0,
    isFetching: false
  });

  const fetchData = ({ pageNo }) => {
    const URL = `${APIs.EDD_ALERTS}key=${state.key}&page=${pageNo ||
      state.pageNo}&page_size=${state.pageSize}&enterprise_id=${
      state.enterpriseId
    }`;
    // ${
    //     state.enterpriseId ? `&enterprise_id=${state.enterpriseId}` : ''
    //   }
    setState({ ...state, isFetching: true });
    getNoAuth({
      url: URL
    })
      .then(response => {
        if (!response) {
          throw Error(response.statusText);
        }
        setState({
          ...state,
          list: response?.data?.result,
          totalPages: response?.data?.pagination?.total_pages,
          totalRecords: response?.data?.pagination?.total_records,
          pageNo: response?.data?.pagination?.current_page,
          isFetching: false
        });
      })
      .catch(function(error) {
        return error;
      });
  };

  const pageInit = () => {
    enterpriseList('enterprise').then(result => {
      if (result?.meta?.status === 200) {
        setState({
          ...state,
          enterprise: {
            ...state.enterprise,
            list: result.result.enterprises
          }
        });
      }
    });
  };

  const handleChange = value => {
    const filteredEnterprise = state.enterprise.list.filter(
      item => item.id === value
    );
    setState({
      ...state,
      enterpriseId: value,
      key: filteredEnterprise?.[0]?.key || null
    });
  };

  const onChange = pageNo => {
    setState({ ...state, pageNo });
    fetchData({ pageNo });
  };

  useEffect(() => {
    pageInit();
  }, []);

  return (
    <div>
      <div className="margin-bottom-20">
        <h2>EDD Data Science (DS) Model Status</h2>
        <i className="">
          Note: This page will get updated soon with the ability to view the
          latest enterprises whose EDD DS Model was updated recently
        </i>
        <a
          href="https://clickpost.atlassian.net/wiki/spaces/PS/pages/2628681816/EDD+Model+Status"
          target="_blank"
          rel="noreferrer"
          className="margin-left-10"
        >
          Doc - LINK
        </a>
      </div>
      <Row>
        <Col span={11} className="margin-bottom-10">
          <Select
            name="enterpriseId"
            id="enterpriseId"
            showSearch
            style={{ width: '96%' }}
            placeholder="Select Enterprise"
            optionFilterProp="children"
            onChange={value => handleChange(value)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            defaultValue={state.enterpriseId || undefined}
          >
            {state.enterprise.list.map((enterprise, i) => (
              <Option key={i} value={enterprise.id}>
                {enterprise.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={11} className="margin-bottom-20 text-center text-left">
          <Button
            type="primary"
            onClick={fetchData}
            disabled={!state.enterpriseId}
          >
            Get Status
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {state.list.length <= 0 ? (
            <div>&nbsp; No Data</div>
          ) : state.isFetching ? (
            <div
              className="text-center spinner-container"
              style={{ height: '300px' }}
            >
              <Spin indicator={antIcon} />
            </div>
          ) : (
            <table className={`ant-table ant-table-small width-100pt relative`}>
              <thead className="ant-table-thead">
                <tr>
                  {columns.map((item, i) => (
                    <th className="padding-8" key={i} width={`${item.width}%`}>
                      {item.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="ant-table-tbody">
                {state.list.map((item, i) => (
                  <tr key={i}>
                    <td className="padding-8">{item.enterprise_user}</td>
                    {/* <td className="padding-8">{item.enterprise_name}</td> */}
                    <td className="padding-8">{item.total_count}</td>
                    <td className="padding-8">
                      {item.model_uploaded.toLocaleString()}
                    </td>
                    <td className="padding-8">
                      {item.is_deleted.toLocaleString()}
                    </td>
                    <td className="padding-8">{item.sla_config_id}</td>
                    <td className="padding-8">
                      {moment(new Date(item.created_at)).format(
                        'Do MMM YY hh:mm a'
                      )}
                    </td>
                    <td className="padding-8">
                      <a
                        href={item.s3_location}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <br />
          {state.totalPages > 1 ? (
            <Pagination
              current={state.pageNo}
              pageSize={state.pageSize}
              onChange={onChange}
              total={state.totalRecords}
              size="small"
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} items`
              }
            />
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default EDD;
